import { render, staticRenderFns } from "./emojiPicker.vue?vue&type=template&id=5eb32d0e&"
import script from "./emojiPicker.vue?vue&type=script&lang=ts&"
export * from "./emojiPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports